<p-sidebar [(visible)]="isVisible" #sidebar position="right" styleClass="w-565">
  <ng-template pTemplate="content">
    <section id="jarvis-extension" *ngIf="isVisible" class="w-800">
      <iframe id="jarvis-frame" [src]="trustedCompanyDomain"> </iframe>
    </section>
  </ng-template>
</p-sidebar>
